import { Box } from '@mui/material';

export const HelpIcon = ({ children }: React.PropsWithChildren) => {
  return (
    <Box
      component='span'
      sx={{
        display: 'inline-flex',
        verticalAlign: 'top',
        backgroundColor: 'background.paper',
        borderRadius: '4px',
      }}
    >
      {children}
    </Box>
  );
};
